<div>
  <h4 class="font-weight-bold mb-3">{{ title }}</h4>

  <!-- <div *ngIf="filesCita.length > 0" cdkDropList  [cdkDropListDisabled]="disabled" cdkDropListOrientation="horizontal" class="example-list" (cdkDropListDropped)="onDropped($event)">
    <div class="example-box" *ngFor="let fileCita of filesCita" id="imgPrincipal" cdkDrag>
      <img src="https://ha-software.com/backend/{{fileCita}}" width="70"> <br>
      <a class="btn btn-link btn-info btn-just-icon like" href="https://ha-software.com/backend/{{fileCita}}" target="_blank">
        <i class="material-icons">remove_red_eye</i>
      </a>

      <a class="btn btn-link btn-danger btn-just-icon" (click)="deleteImg(fileCita)"><i class="material-icons">delete</i></a>
    </div>
  </div> -->
  <div
    *ngIf="!readonly"
    class="drop-zone"
    style="position: relative"
    [ngClass]="{ 'drag-disabled': disabled }"
  >
    <span class="mr-2"> Drag and drop here... or </span>
    <div class="gts-btn-primary" [ngClass]="{ 'gts-btn-disabled': disabled }">
      <span class="gts-btn-text"> Browse files </span>
    </div>
    <input
      type="file"
      multiple
      id="sendfile"
      (change)="selectFiles($event)"
      [disabled]="disabled"
    />
  </div>
  <div class="files-container">
    <div *ngFor="let fileCita of filesCita" class="d-flex">
      <div [ngSwitch]="tipo(fileCita.file)" class="mr-3">
        <div *ngSwitchCase="'imagen'">
          <a class="btn btn-just-icon" (click)="lightboxOpen(fileCita.id)">
            <img [src]="getFileUrl(fileCita)" width="40" height="40" />
          </a>
        </div>
        <div *ngSwitchCase="'excel'">
          <a style="color: green">
            <i class="fa fa-file-excel-o fa-3x" aria-hidden="true"></i>
          </a>
        </div>
        <div *ngSwitchCase="'pdf'">
          <a style="color: #a93226">
            <i class="fa fa-file-pdf-o fa-3x" aria-hidden="true"></i>
          </a>
        </div>
        <div *ngSwitchCase="'texto'">
          <a>
            <i class="fa fa-file-o fa-3x" aria-hidden="true"></i>
          </a>
        </div>
        <div *ngSwitchCase="'word'">
          <a style="color: #21618c">
            <i class="fa fa-file-word-o fa-3x" aria-hidden="true"></i>
          </a>
        </div>
        <div *ngSwitchCase="'powerpoint'">
          <a style="color: #a93226">
            <i class="fa fa-file-powerpoint-o fa-3x" aria-hidden="true"></i>
          </a>
        </div>
        <div *ngSwitchCase="'zip'">
          <a>
            <i class="fa fa-file-archive-o fa-3x" aria-hidden="true"></i>
          </a>
        </div>
        <div *ngSwitchDefault>
          <a>
            <i class="fa fa-file-o fa-3x" aria-hidden="true"></i>
          </a>
        </div>
      </div>
      <div id="imgPrincipal{{ fileCita.id }}" class="w-100">
        <div>
          <a style="color: black" target="_blank" [href]="getFileUrl(fileCita)">
            <span class="label-file">Filename:</span>
            <span class="file-name">
              {{ fileCita.file }}
            </span>
          </a>
          <br />
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex">
              <div class="pr-3 caption-text-container">
                <i class="material-icons icon-caption">perm_identity </i>
                <span class="label-file" style="vertical-align: bottom">
                  Uploaded By:
                </span>
                <span class="caption-text">
                  {{ fileCita.name }} {{ fileCita.surname }}
                </span>
              </div>
              <div class="caption-text-container">
                <i class="material-icons icon-caption"> date_range </i>
                <span class="label-file" style="vertical-align: bottom">
                  Date-time:
                </span>
                <span class="caption-text">
                  {{ fileCita.fecha | Fechagts }}
                </span>
              </div>
            </div>
            <div>
              
              <button
                class="btn btn-just-icon btn-link btn-primary"
                *ngIf="type === 'FILESBATCH'"
                matTooltip="Send to CV Files"
              >
               

                <span class="material-icons"   (click)="copyfiletoerasureport(fileCita.id)">
                  drive_folder_upload
                  </span>
              </button>
              <a
                style="color: black"
                target="_blank"
                [href]="getFileUrl(fileCita)"
                matTooltip="Download"
              >
                <i *ngIf="!readonly" class="material-icons"> download </i>
              </a>
              <button
                class="btn btn-just-icon btn-link btn-danger"
                *ngIf="canDelete"
                matTooltip="Delete"
              >
                <i
                  *ngIf="!readonly"
                  class="material-icons"
                  (click)="delete(fileCita.id)"
                >
                  delete
                </i>
              </button>
            </div>
          </div>
        </div>
        <hr class="divition" />
      </div>
    </div>
  </div>
  <div *ngIf="filesCita.length" class="">
    <div class="d-flex justify-content-end mb-3">
      <button class="gts-btn-primary-outline" (click)="download()">
        <span class="gts-btn-icon-left">file_download</span>
        <span class="gts-btn-text" *ngIf="filesCita.length == 1">
          Download
        </span>
        <span class="gts-btn-text" *ngIf="filesCita.length > 1">
          Download All
        </span>
      </button>
    </div>
  </div>

  <div
    *ngFor="let progressInfo of progressInfos"
    class="mb-2"
    [hidden]="progressInfo.value === 100"
  >
    <span>{{ progressInfo.fileName }}</span>
    <div class="progress" style="height: 20px !important">
      <div
        class="progress-bar progress-bar-info progress-bar-striped"
        role="progressbar"
        attr.aria-valuenow="{{ progressInfo.value }}"
        aria-valuemin="0"
        aria-valuemax="100"
        [ngStyle]="{ width: progressInfo.value + '%' }"
      >
        {{ progressInfo.value }}%
      </div>
    </div>
  </div>

  <!-- <div class="text-center">
    <div class="progress" style="height: 20px !important; max-width: 600px;">
      <div class="progress-bar" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div>
    </div>
  </div> -->

  <div *ngIf="message !== ''" class="alert alert-success" role="alert">
    {{ message }}
  </div>
</div>
